import {networkDeviceContentConstants} from "../constants/network-device-content.constants";
import {networkDeviceContentService} from "../services/network-device-content.service";
import {modalActions} from "./modal.actions";

const getNetworkDeviceContentById = (networkDeviceId, refresh = true) => {
    return dispatch => {
        if(refresh)
            dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_ID_REQUEST});

        networkDeviceContentService.getNetworkDeviceContentById(networkDeviceId)
            .then(
                (networkDeviceContentModel) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_ID_SUCCESS, networkDeviceContentModel})
                },
                (error) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_ID_FAILURE, error})
                }
            )
    };
};

const getDefaultApp = () => {
    return dispatch => {
        dispatch({ type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_DEFAULT_APP_REQUEST });
        networkDeviceContentService.getDefaultApplication()
            .then(
                (defaultAppModel) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_DEFAULT_APP_SUCCESS, defaultAppModel})
                },
                (error) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_DEFAULT_APP_FAILURE, error})
                }
            )
    };
};

const getLauncherDropdown = (networkDeviceId) => {
    return dispatch => {
        dispatch({type: networkDeviceContentConstants.LAUNCHER_DROPDOWN_REQUEST});
        networkDeviceContentService.getLauncherDropdown(networkDeviceId)
            .then(
                (launcherList) => {
                    dispatch({type:networkDeviceContentConstants.LAUNCHER_DROPDOWN_SUCCESS, launcherList })
                },
                (error) => {
                    dispatch({type:networkDeviceContentConstants.LAUNCHER_DROPDOWN_FAILURE, error })
                }
            )
    }
}

const getNetworkDeviceContentByContentId = (contentId) => {
    return dispatch => {
        dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_REQUEST});
        networkDeviceContentService.getNetworkDeviceContentByContentId(contentId)
            .then(
                (networkDeviceContentModel) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_SUCCESS, networkDeviceContentModel})
                },
                (error) => {
                    dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_BY_CONTENT_ID_FAILURE, error});
                }
            )
    };
};

const setDefaultContent = (networkDeviceContent) => {
    return dispatch => {
        networkDeviceContentService.setDefaultContent(networkDeviceContent.id, !networkDeviceContent.isDefault)
            .then(
                () => dispatch(getNetworkDeviceContentById(networkDeviceContent.networkDeviceId)),
                (error) => console.log(error)
            );
    };
};

const removeContent = (networkDeviceContentId, networkDeviceId) => {
    return dispatch => {
        networkDeviceContentService.deleteNetworkDeviceContent(networkDeviceContentId)
            .then(
                () => dispatch(getNetworkDeviceContentById(networkDeviceId)),
                (error) => console.log(error)
            )
    };
};

const retryContent = (networkDeviceContentId, networkDeviceId) => {
    return dispatch => {
        networkDeviceContentService.retryNetworkDeviceContent(networkDeviceContentId)
            .then(
                () => dispatch(getNetworkDeviceContentById(networkDeviceId)),
                (error) => console.log(error)
            );
    }
};

const copyContent = (contentModel) => {
    return dispatch => {
            networkDeviceContentService.copyNetworkDeviceContent({
                contentId: contentModel.id,
                exhibitionScenarioId: contentModel.exhibitionScenarioId || 0
            })
                .then(
                    () => {
                        dispatch(modalActions.hideModal());
                        dispatch(getNetworkDeviceContentByContentId(contentModel.networkDeviceId))
                    },
                    (error) => console.log(error)
                )
     }
}

const clearStore = () => {
    return dispatch => {
        dispatch({type: networkDeviceContentConstants.NETWORK_DEVICE_CONTENT_CLEAR })
    }
};

export const networkDeviceContentActions = {
    getNetworkDeviceContentById,
    getNetworkDeviceContentByContentId,
    getDefaultApp,
    getLauncherDropdown,
    setDefaultContent,
    clearStore,
    removeContent,
    retryContent,
    copyContent,
};
